var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C11.2044 0 10.4413 0.351189 9.87868 0.976311C9.31607 1.60143 9 2.44928 9 3.33333V3.90167C5.505 5.275 3 8.98 3 13.3333V21.6667H1.5C1.10218 21.6667 0.720645 21.8423 0.43934 22.1548C0.158036 22.4674 0 22.8913 0 23.3333C0 23.7754 0.158036 24.1993 0.43934 24.5118C0.720645 24.8244 1.10218 25 1.5 25H22.5C22.8978 25 23.2794 24.8244 23.5607 24.5118C23.842 24.1993 24 23.7754 24 23.3333C24 22.8913 23.842 22.4674 23.5607 22.1548C23.2794 21.8423 22.8978 21.6667 22.5 21.6667H21V13.3333C21.0002 11.2649 20.4234 9.24723 19.3489 7.55815C18.2743 5.86906 16.755 4.59161 15 3.90167V3.33333C15 2.44928 14.6839 1.60143 14.1213 0.976311C13.5587 0.351189 12.7956 0 12 0ZM12 30C11.2044 30 10.4413 29.6488 9.87868 29.0237C9.31607 28.3986 9 27.5507 9 26.6667H15C15 27.5507 14.6839 28.3986 14.1213 29.0237C13.5587 29.6488 12.7956 30 12 30Z",
    fill: "#48C9F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/NotificationBell.913c17c8f754555b0af9c4ead9f3f4c5.svg";
export { ForwardRef as ReactComponent };